import React, { useState } from "react";
import {
  AccountBalance,
  AcUnit,
  Camera,
  CreditCard,
  DoubleArrow,
  DynamicFeed,
  Edit,
  Pix,
  Toll,
} from "@mui/icons-material";
import { tooltipStyleProps } from "services/constants/Styles";
import { Tooltip, Drawer } from "@mui/material";
import { showToast } from "services/utils/Status";
import { Incentive } from "./Incentive";

import {
  drawerStyle,
  editIconStyle,
  doubleArrowStyle,
  parentBoxStyle,
  childBoxStyleSpaceBetween,
} from "services/constants";

import {
  Box,
  Typography,
  IconButton,
  Paper,
  Card,
  Grid,
  Avatar,
  CardContent,
} from "@mui/material";

export const ViewIncentive = ({
  onClose,
  selectedIncentiveData,
  reCallApi,
  setHandleLoader,
}) => {
  const [isEditPanelOpen, setIsEditPanelOpen] = useState(false);
  const screenAccess = true;

  const payrollGrpData = [
    {
      id: 1,
      label: "Incentive Template Name",
      value: selectedIncentiveData?.name,
      icon: AccountBalance,
      variant: "blue",
    },
    {
      id: 2,
      label: "Incentive Type",
      value: selectedIncentiveData?.incentive_type,
      icon: DynamicFeed,
      variant: "red",
    },

    {
      id: 3,
      label: "Qualification Condition",
      value:
        selectedIncentiveData?.qualification_type === "Percentage"
          ? `${selectedIncentiveData?.qualification_value}% of ${selectedIncentiveData?.incentive_type}`
          : `${selectedIncentiveData?.incentive_type} count : ${selectedIncentiveData?.qualification_value}`,
      icon: AcUnit,
      variant: "grey",
    },
    {
      id: 4,
      label: "Eligibility Logic",
      value: selectedIncentiveData?.eligibility_logic,
      icon: Camera,
      variant: "grey",
    },
    {
      id: 5,
      label: "Payout Type",
      value: selectedIncentiveData?.payout_type_display,
      icon: CreditCard,
      variant: "blue",
    },
    {
      id: 6,
      label: "Payout Value",
      value: selectedIncentiveData?.payout_value,
      icon: Pix,
      variant: "indigo",
    },
    {
      id: 7,
      label: "Payout Basis",
      value: selectedIncentiveData?.payout_basis,
      icon: Toll,
      variant: "green",
    },
  ];

  const hanldeEditPanel = () => {
    setIsEditPanelOpen(true);
  };

  const handleClosePanel = () => {
    setIsEditPanelOpen(false);
  };

  return (
    <>
      <Box sx={parentBoxStyle}>
        <Paper elevation={0} sx={{ borderRadius: 0 }}>
          <Box>
            <Box sx={childBoxStyleSpaceBetween}>
              <IconButton onClick={onClose} sx={doubleArrowStyle}>
                <DoubleArrow />
              </IconButton>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Tooltip title="Edit" arrow slotProps={tooltipStyleProps}>
                  <IconButton
                    onClick={() => {
                      if (screenAccess) {
                        hanldeEditPanel();
                      } else {
                        showToast(
                          "error",
                          `Access denied: You are not authorized to edit payrun cycle`,
                        );
                      }
                    }}
                    sx={editIconStyle}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            <Box sx={{ ml: 2.2 }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Incentive Template
              </Typography>
              <Typography variant="body2" color="text.secondary">
                View your incentive rule.
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 3,
              mt: 2,
              mb: 2,
            }}
          >
            <Grid container spacing={{ xs: 4, md: 6 }}>
              {payrollGrpData.map((item) => {
                const IconComponent = item.icon;
                const isBlue = item.variant === "blue";

                return (
                  <Grid
                    item
                    xs={12}
                    sm={[1, 2, 3, 4].includes(item.id) ? 6 : 4}
                    key={item.id}
                  >
                    <Card
                      sx={{
                        bgcolor: "#3c73e70d",
                        borderRadius: "5px",
                        border: 0,
                        boxShadow: "0px 4px 4px #00000040",
                      }}
                    >
                      <CardContent sx={{ p: 2 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 2,
                            mb: 2,
                          }}
                        >
                          <Avatar
                            variant="rounded"
                            sx={{
                              width: 35,
                              height: 35,
                              bgcolor: isBlue ? "#3c73e71a" : "#bd09091a",
                              border: `0.5px solid ${item?.variant}`,
                              boxShadow: "0px 1px 2px #00000040",
                              color: item?.variant,
                            }}
                          >
                            <IconComponent
                              size={18}
                              color={isBlue ? "#3c73e7" : "#d71515"}
                            />
                          </Avatar>
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 600,
                              mb: "auto",
                            }}
                          >
                            {item.label}
                          </Typography>
                        </Box>
                        <Box sx={{ pl: 1 }}>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 700,
                              color: "#32325D",
                            }}
                          >
                            {item.value}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Box>
      </Box>
      <Drawer
        anchor="right"
        open={isEditPanelOpen}
        onClose={() => {
          handleClosePanel();
        }}
        sx={drawerStyle}
      >
        <Incentive
          onClose={() => setIsEditPanelOpen(false)}
          reCallApi={reCallApi}
          selectedIncentiveData={selectedIncentiveData}
          isEdit={true}
          setHandleLoader={setHandleLoader}
        />
      </Drawer>
    </>
  );
};
